import { render, staticRenderFns } from "./DividerWithText.vue?vue&type=template&id=43d6a7d8&"
import script from "./DividerWithText.vue?vue&type=script&lang=ts&"
export * from "./DividerWithText.vue?vue&type=script&lang=ts&"
import style0 from "./DividerWithText.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
